import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import { Card, NavLink, Table, Row, Col, Button, Spinner, } from 'reactstrap';
import { Link } from 'react-router-dom';
import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import {
    CONFIG_BASE_API_URL,
} from '../constans';

export class TrainingDetailPage extends Component {
    static displayName = TrainingDetailPage.name;

    constructor(props) {
        super(props);
        this.state = {
            definition: {},
            results: [],
            loading: true
        };

        this.renderTrainingDetail = this.renderTrainingDetail.bind(this);
    }

    componentDidMount() {
        this.populateTrainingDetailData();
    }

    renderTrainingDetail() {
        return (
            <React.Fragment>
                <Row>
                    <Col className="pt-2">
                        <h2>{this.state.definition.name}</h2>
                        <h6>{this.state.definition.description}</h6>
                        <hr />
                    </Col>
                </Row>
                <Row xs="1" sm="2">

                    <Col className="pl-0 d-none d-sm-block">
                        <div className="border shadow-sm text-left p-4 my-3">
                            <h3>Leren</h3>
                            <p>Om je voor te bereiden op het examen kun je de theorie van deze training doornemen.</p>
                            <div className="text-right">
                                <a href={this.state.trainingUrl} target="_blank" className="btn btn-primary text-light" role="button">Ga naar de lessen</a>
                            </div>
                        </div>
                    </Col>
                    <Col className="pr-0 d-none d-sm-block">
                        <div className="border shadow-sm text-left p-4 my-3">
                            <h3>Examen</h3>
                            <p>Als je denkt dat je de kennis beheerst kun je een poging wagen om het examen te halen.</p>
                            <div className="text-right">
                                <Button tag={Link} to={this.state.examUrl} color="primary">
                                    Examen maken
                                </Button>
                            </div>
                        </div>
                    </Col>

                    <Col className="px-0 d-block d-sm-none">
                        <div className="border shadow-sm text-left p-4 my-3">
                            <h3>Leren</h3>
                            <p>Om je voor te bereiden op het examen kun je de theorie van deze training doornemen.</p>
                            <div className="text-right">
                                <a href={this.state.trainingUrl} target="_blank" className="btn btn-primary text-light" role="button">Ga naar de lessen</a>
                            </div>
                        </div>
                    </Col>
                    <Col className="px-0 d-block d-sm-none">
                        <div className="border shadow-sm text-left p-4 my-3">
                            <h3>Examen</h3>
                            <p>Als je denkt dat je de kennis beheerst kun je een poging wagen om het examen te halen.</p>
                            <div className="text-right">
                                <Button tag={Link} to={this.state.examUrl} color="primary">
                                    Examen maken
                                </Button>
                            </div>
                        </div>
                    </Col>

                </Row>
                {this.state.results.length > 0 &&
                    <Row>
                        <Col className="px-0">
                            <div className="border shadow-sm text-left p-4 my-3">
                                <h3>Eerdere resultaten</h3>
                                    <Table size="sm" responsive hover>
                                    <thead>
                                        <tr>
                                            <th>Starttijd</th>
                                            <th className="d-none d-sm-block">Duur</th>
                                            <th>Score</th>
                                            <th>Resultaat</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {this.state.results.map((examResult) => {
                                            var startDate = new Date(Date.parse(examResult.startTime));
                                            var stopTime = new Date(Date.parse(examResult.stopTime));
                                            var duration = formatDistanceStrict(stopTime, startDate);
                                            var formatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };

                                            return (
                                                <tr key={examResult.id} >
                                                    <td>{startDate.toLocaleDateString("nl", formatOptions)}</td>
                                                    <td className="d-none d-sm-block">{duration}</td>
                                                    <td scope="row">{examResult.score}%</td>
                                                    <td>{examResult.state === 1 ?
                                                        <div className="badge badge-success">GESLAAGD</div>
                                                        :
                                                        <div className="badge badge-danger">GEZAKT</div>
                                                    }
                                                    </td>
                                                    <td className="text-right">
                                                        <a href={"/trainingresult/" + examResult.id}>Details</a>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                }
                <div className="text-left">
                    <Button className="mb-5 mt-3" tag={Link} to={"/training"} color="primary">
                        Terug naar trainingen
                    </Button>
                </div>
            </React.Fragment>
        );
    }

    render() {
        let contents = this.state.loading
            ?
            <Row>
                <div className="col-sm center-loading-spinner">
                    <Spinner className="spinner-settings" type="border" color="primary" />
                    <div className="pt-4">Training data laden...</div>
                </div>
            </Row>
            : this.renderTrainingDetail();

        return (
            <React.Fragment>
                {contents}
            </React.Fragment>
        );
    }

    //GetAvailableTrainingsAsync
    async populateTrainingDetailData() {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/training/' + this.props.match.params.id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
            // voor nu niks later generieke toast laten zien met foutmelding
        }
        this.setState({
            definition: data.responseData.definition,
            results: data.responseData.results,
            trainingUrl: data.responseData.trainingUrl,
            examUrl: data.responseData.examUrl,
            loading: false
        });
    }
}